import { Label } from "../../../label/Label";
import { LabelProps } from "../../../label/LabelProps";
import { Table } from "../../Table";

export class RowCountLabel extends Label {
    private readonly table: Table;

    constructor(table: Table, props?: Partial<LabelProps>) {
        super({
            text: "No Results",
            marginLeft: 8,
            fontSize: 16,
            color: "#9E9E9E",
            minWidth: 75,
            visible: false,
            wrap: false,
            ...props
        });
        this.table = table;
    }
    
    refresh() {
        const count = this.table.filteredRows?.length;
        if (count === 0 || this._designer != null)
            this.text = "No Results";
        else if (count === 1)
            this.text = "1 Result";
        else
            this.text = count + " Results";
    }
}
